import { DatastoreProvider, InstanceDashboard } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { type RoutePath, useLocalSearchParams } from 'expo-router';
import { SkeletonDashboardScreen } from 'structure/admin/dashboard-loading-screen';
import { editorialDashModuleQuery } from 'system/structure-modules';

export function SuspenseFallback() {
    return <SkeletonDashboardScreen />;
}

export default function EditorialDashboardLayout() {
    const { siloKey } = useLocalSearchParams<Extract<RoutePath, `/[siloKey]/editorialdash/one/${string}`>>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'editorialdash',
        instanceKey: 'one',
        moduleQuery: editorialDashModuleQuery,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceDashboard loadingScreen={<SkeletonDashboardScreen />} />
        </DatastoreProvider>
    );
}
